import { lazy, type FC } from 'react';

import { ReactComponent as DocumentConfirmImage } from '@/assets/images/conversion/document-confirm-image.svg';
import createConverter, { CreateConverterProps } from '@/components/hoc/createConverter';
import withConfirmation from '@/components/hoc/withConfirmation';

const AdvertisingSection = lazy(() => import('@/components/conversion/footers/DocumentFooter'));

const DocumentConverter: FC<CreateConverterProps> = ({ children }) => {
  return (
    <div className="tw-relative tw-bg-white tw-py-5 tw-p-5 sm:tw-p-[32px] tw-border-3 tw-border-ui-light-grey tw-rounded-t-footer">
      {children}
    </div>
  );
};

export default createConverter(
  DocumentConverter,
  'document',
  {
    dropzoneHeading: 'pdfextra_convert_tool.dropzone.document.heading',
    showConvertOcrButton: true,
    ConfirmationComponent: withConfirmation(DocumentConfirmImage),
  },
  AdvertisingSection
);
